import { CircularProgress, Grid } from '@mui/material'

const GridCircularProgress = ({ color, size }) => (
  <Grid size={12}>
    <center>
      <CircularProgress color={color} size={size} disableShrink />
    </center>
  </Grid>
)

export default GridCircularProgress
